import React, { useState, useEffect } from "react";
import "./Bind_Mailbox.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { Button, Form } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { SendEmailOTP, VerifyOTP, AuthUpdate, GETAuthLogin } from "../../features/auth/Slice";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { useNavigate } from "react-router-dom";

const OTP_TIMER = 60;

function Bind_Mailbox() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showEmail, setShowEmail] = useState(false);
  const [emailLocked, setEmailLocked] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [countdown, setCountdown] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("Successful");

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: { email: "", otp: "" },
  });

  const user = useSelector((state => state.auth));

  useEffect(() => { dispatch(GETAuthLogin()) }, [dispatch]);
  useEffect(() => { reset(user?.data) }, [dispatch]);

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleChangeEmail = () => {
    setEmailLocked(false);
    setOtpSent(false);
    setOtpVerified(false);
    setOtpError("");
    setCountdown(0);
    setValue("otp", "");
  };

  const handleSendOTP = async () => {
    const email = watch("email");
    const emailRegex = /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
    if (!email || !emailRegex.test(email)) {
      setOtpError("Please enter a valid email first");
      return;
    }
    setOtpError("");
    setOtpLoading(true);
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("type", "email");

      const res = await dispatch(SendEmailOTP(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setEmailLocked(true);
        setOtpSent(true);
        setOtpVerified(false);
        setCountdown(OTP_TIMER);
        setOtpError("");
      } else {
        setOtpError(res?.payload?.errors || "Failed to send OTP. Try again.");
      }
    } catch {
      setOtpError("Something went wrong.");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    const otp = watch("otp");
    const email = watch("email");
    if (!otp || otp.length < 4) {
      setOtpError("Please enter the OTP");
      return;
    }
    setOtpError("");
    setVerifyLoading(true);
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("otp", otp);
      formData.append("type", "email");

      const res = await dispatch(VerifyOTP(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setOtpVerified(true);
        setOtpError("");
      } else {
        setOtpError(res?.payload?.errors || "Invalid OTP. Try again.");
      }
    } catch {
      setOtpError("Something went wrong.");
    } finally {
      setVerifyLoading(false);
    }
  };

  const onSubmit = async (data) => {
    // Block submit if OTP not verified
    if (!otpVerified) {
      setOtpError("Please verify your OTP first");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("email", data?.email);
      formData.append("otp", data?.otp);

      const res = await dispatch(AuthUpdate(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        reset();
        setEmailLocked(false);
        setOtpSent(false);
        setOtpVerified(false);
        setModalMessage(res?.payload?.data || "Email bound successfully!");
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
          navigate(-1);
        }, 3000);
      } else {
        setModalMessage(res?.payload?.errors || "Update failed.");
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
        setOtpError(res?.payload?.errors || "Binding failed. Try again.");
      }
    } catch (error) {
      console.error("Bind mailbox error:", error);
    }
  };

  return (
    <>
      <section className="Bind_Mailbox login-page">
        <Common_white_header headingText={"Bind Mailbox"} />

        <div className="container">
          <Form onSubmit={handleSubmit(onSubmit)} noValidate>

            {/* Email */}
            <div className="form-group field_holder">
              <Form.Label className="d-flex justify-content-between align-items-center">
                <span>
                  <img src="/assets/images/icons/envolope.png" alt="icon" className="login_lable_icons" />{" "}
                  Mail
                </span>
                {emailLocked && (
                  <small
                    className="text-primary"
                    style={{ cursor: "pointer", fontSize: "12px" }}
                    onClick={handleChangeEmail}
                  >
                    Change Email
                  </small>
                )}
              </Form.Label>

              <div className="password_input">
                <Form.Control
                  type={showEmail ? "text" : "email"}
                  placeholder="Please input your email"
                  disabled={emailLocked}
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                      message: "Enter a valid email address",
                    },
                  })}
                />
                <span className="eye-icon" onClick={() => setShowEmail(!showEmail)}>
                  {showEmail ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              {errors.email && (
                <small className="text-danger">{errors.email.message}</small>
              )}
            </div>

            {/* OTP */}
            <div className="form-group field_holder invite_code_wrapper">
              <Form.Label>
                <img src="/assets/images/icons/sheild.png" alt="icon" className="login_lable_icons" />{" "}
                Verification Code
                {otpVerified && <small className="text-success ms-2">✔ Verified</small>}
              </Form.Label>

              <div className="invite_input">
                <Form.Control
                  type="text"
                  placeholder="Please Enter the Confirmation Code"
                  disabled={otpVerified}
                  {...register("otp", {
                    required: "Verification code is required",
                    minLength: { value: 4, message: "Enter a valid OTP" },
                  })}
                />

                {/*
                  Flow:
                  1. Not sent yet         → "Send"
                  2. Sent + timer running → "Verify OTP (Xs)"  ← clicks VerifyEmailOTP
                  3. Timer expired        → "Resend"
                  4. Verified             → button hidden
                */}
                {!otpVerified && (
                  !otpSent || countdown === 0 ? (
                    <Button
                      className="send_btn"
                      type="button"
                      onClick={handleSendOTP}
                      disabled={otpLoading}
                    >
                      {otpLoading ? "Sending..." : otpSent ? "Resend" : "Send"}
                    </Button>
                  ) : (
                    <Button
                      className="send_btn"
                      type="button"
                      onClick={handleVerifyOTP}
                      disabled={verifyLoading}
                    >
                      {verifyLoading ? "Verifying..." : `Verify OTP (${countdown}s)`}
                    </Button>
                  )
                )}
              </div>

              {otpError && <small className="text-danger d-block mt-1">{otpError}</small>}
              {errors.otp && <small className="text-danger d-block">{errors.otp.message}</small>}
            </div>

            <button
              type="submit"
              className="btn_register_bg mt-4"
              disabled={isSubmitting || !otpVerified}
            >
              {isSubmitting ? "Binding..." : "Bind"}
            </button>

          </Form>
        </div>
      </section>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default Bind_Mailbox;